module.exports = __webpack_public_path__ + "static/media/cpanel.9d951c25.svg";